// ==============================|| FRONTEND MENU ITEMS ||============================== //

import { IconHome, IconMessage, IconMusic, IconNews, IconUsersGroup } from '@tabler/icons-react';

const frontendPages = [
    {
        id: 'home-tools',
        title: 'Home',
        type: 'group',

        children: [
            {
                id: 'dashboard',
                title: 'Home',
                icon: IconHome,
                type: 'item',
                url: '',
                breadcrumbs: false
            },
            {
                id: 'artists',
                title: 'Artists',
                type: 'item',
                icon: IconMusic,
                url: 'artists',
                breadcrumbs: false
            },
            {
                id: 'shows',
                title: 'Shows',
                type: 'item',
                icon: IconMusic,
                url: 'shows',
                breadcrumbs: false
            },
            {
                id: 'news',
                title: 'News',
                type: 'item',
                icon: IconNews,
                url: 'news',
                breadcrumbs: false
            },
            {
                id: 'awareness-team',
                title: 'Awareness Team',
                type: 'item',
                icon: IconUsersGroup,
                url: 'awareness-team',
                breadcrumbs: false
            },
            {
                id: 'about',
                title: 'About',
                type: 'item',
                icon: IconMessage,
                url: 'about',
                breadcrumbs: false
            }
        ]
    }
];

export { frontendPages };
